/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 10:23:01 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { 
  Datagrid, 
  List, 
  TextField, 
  usePermissions, 
  Title, 
  EditButton 
} from 'react-admin';
import { Pagination } from '../../Components';

const TemplateList = props => {
  return <>
      <List
        bulkActionButtons={false}
        exporter={false}
        pagination={<Pagination />}
        perPage={50}
        // actions={<ListActions />}
        {...props}
      >
        <Datagrid>
          <TextField
            source="name"
            label="Name"
            sortable={false}
          />
          <EditButton />
        </Datagrid>
      </List>
    </>
  
};

export default TemplateList;
